import { Slider } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled, { css } from 'styled-components';

import { ReactComponent as VolumeOffControlBar } from 'assets/volumeOffControlBar.svg';
import { ReactComponent as VolumeOffVolumeBar } from 'assets/volumeOffVolumeBar.svg';
import { ReactComponent as VolumeUpControlBar } from 'assets/volumeUpControlBar.svg';
import { ReactComponent as VolumeUpVolumeBar } from 'assets/volumeUpVolumeBar.svg';
import ColormapInterface from 'shared-types/colormapinterface';
import { getSpacing } from 'stylesheetB2b';

export const SliderContainer = styled.div`
  width: 88%;
`;

const VOLUME_BAR_HEIGHT = getSpacing(1.1);
const THUMB_HEIGHT = getSpacing(3.9);
const VOLUME_BAR_Z_INDEX = 5000;

export const VolumeSlider = muiStyled(Slider)<{ colors: ColormapInterface }>(({ colors }) => ({
  display: 'flex',
  alignItems: 'center',
  '& .MuiSlider-track': {
    height: VOLUME_BAR_HEIGHT,
    backgroundColor: colors.volumeBar,
  },
  '& .MuiSlider-thumb': {
    height: THUMB_HEIGHT,
    width: THUMB_HEIGHT,
    backgroundColor: colors.volumeBar,
    marginTop: 'auto',
  },
  '& .MuiSlider-rail': {
    height: VOLUME_BAR_HEIGHT,
    marginTop: 'auto',
    backgroundColor: colors.volumeBarSliderRails,
  },
}));

export const ControlBarIconStyle = css`
  font-size: ${getSpacing(9)};
  margin-top: 5%;
`;

export const VolumeBarIconStyle = (color: string | undefined) => css`
  color: ${color};
  height: 45%;
  width: 84%;
`;

export const ControlBarVolumeUpIcon = styled(VolumeUpControlBar)`
  ${ControlBarIconStyle};
`;

export const VolumeBarVolumeUpIcon = styled(VolumeUpVolumeBar)<{ colors: ColormapInterface }>`
  ${({ colors }) => VolumeBarIconStyle(colors.volumeBar)};
`;

export const ControlBarVolumeOffIcon = styled(VolumeOffControlBar)`
  ${ControlBarIconStyle};
`;

export const VolumeBarVolumeOffIcon = styled(VolumeOffVolumeBar)<{ colors: ColormapInterface }>`
  ${({ colors }) => VolumeBarIconStyle(colors.volumeBar)};
`;

interface VolumeBarContainerProps {
  $on: boolean;
  colors: ColormapInterface;
}

export const VolumeBarIconContainer = styled.div`
  height: 100%;
  width: 10%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const VolumeBarContainer = styled.div<{ $on: boolean; colors: ColormapInterface }>`
  position: absolute;
  top: -12.5%;
  height: ${getSpacing(11.6)};
  width: ${getSpacing(63)};
  left: ${getSpacing(-30)};
  background: ${({ colors }) => colors.VolumeBarContainer};
  display: ${(props: VolumeBarContainerProps) => (props.$on ? 'flex' : 'none')};
  align-items: center;
  justify-content: space-between;
  border-radius: ${getSpacing(3)};
  padding-right: ${getSpacing(6)};
  padding-left: ${getSpacing(2.8)};
  z-index: ${VOLUME_BAR_Z_INDEX};
`;

export const VolumeContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  height: 100%;
  width: 10%;
`;

export const VolumeIconContainer = styled.div`
  height: 60%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  margin-top: 5%;
  cursor: pointer;
`;

export const VolumeIconSubContainer = styled.div`
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
